import {
  CompanyDocument,
  NaturalPersonDocument,
} from "../../api/commercial/generated-types";

export const COMPANY_AS_SELECTION: string = "COMPANY";

export interface CompanyOnlineModel {
  authorizedRepresentatives: NaturalPersonDocument[];
  companyName: CompanyDocument["name"];
  selectedStatementRecipient: string;
  selectedCardsAndPinRecipient: string;
  companyOnlineSecurityCode: string | undefined;
  acceptMarketingEmails: boolean;
}
